// extracted by mini-css-extract-plugin
export var carrierTab = "_5l-0";
export var carrierTabActive = "_5l-1 _5l-0";
export var carrierTabInactive = "_5l-2 _5l-0";
export var carrierTabLabel = "_5l-3";
export var carrierTabLabelActive = "_5l-4 _5l-3";
export var carrierTabLabelInactive = "_5l-5 _5l-3";
export var carrierTabPercentage = "_5l-6";
export var carrierTabPercentageActive = "_5l-7 _5l-6";
export var carrierTabPercentageInactive = "_5l-8 _5l-6";
export var carrierTabWinnable = "_5l-9";
export var carrierTabWinnableActive = "_5l-a _5l-9";
export var carrierTabWinnableInactive = "_5l-b _5l-9";
export var comparisonContainer = "_5l-d";
export var missingRateButton = "_5l-n";
export var missingRateButtonActive = "_5l-o _5l-n";
export var missingRateButtonInactive = "_5l-p _5l-n";
export var missingRateButtonLabel = "_5l-q";
export var missingRateButtonLabelActive = "_5l-r _5l-q";
export var missingRateButtonLabelInactive = "_5l-s _5l-q";
export var sidebar = "_5l-c";
export var strategyButton = "_5l-e";
export var strategyButtonActive = "_5l-f _5l-e";
export var strategyButtonDescription = "_5l-k";
export var strategyButtonDescriptionActive = "_5l-l _5l-k";
export var strategyButtonDescriptionInactive = "_5l-m _5l-k";
export var strategyButtonInactive = "_5l-g _5l-e";
export var strategyButtonLabel = "_5l-h";
export var strategyButtonLabelActive = "_5l-i _5l-h";
export var strategyButtonLabelInactive = "_5l-j _5l-h";
export var unitToggleButton = "_5l-t";
export var unitToggleButtonActive = "_5l-u _5l-t";
export var unitToggleButtonInactive = "_5l-v _5l-t";
export var unitToggleButtonLabel = "_5l-w";
export var unitToggleButtonLabelActive = "_5l-x _5l-w";
export var unitToggleButtonLabelInactive = "_5l-y _5l-w";